import React, { useEffect, useState } from "react";

export default function AboutItem( {img, text} ) {

    
  const [close, setClose] = useState(false)

  const closeF = () => {
    setClose(!close)
  }
 

  return (
    <p onMouseEnter={closeF} onMouseLeave={closeF} className="list-item">
    <img className={`topleft ${close ? "topleftcloser" : ""} `} width="50" height="50" src="https://img.icons8.com/ios/50/cf291e/expand-arrow--v2.png" alt="expand-arrow--v2"/>
    <img className={`bottomright ${close ? "bottomrightcloser" : ""} `}  width="50" height="50" src="https://img.icons8.com/ios/50/cf291e/expand-arrow--v2.png" alt="expand-arrow--v2"/>
    <img width="50" height="50" src={img} alt="commercial--v1"/>
    {text}
    </p>
  )
}
